export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15141.4f7a7e30.jpg";